import { useCallback } from 'react';
import {
	VELOCITY_CUSTOM_WALLET_OPTIONS,
	VelocityWalletName,
} from 'src/constants/wallets';
import useTryConnectAppKit from 'src/hooks/useTryConnectAppKit';
// Reown / WalletConnect wallet options are disabled for now.
// import Env from 'src/environmentVariables/EnvironmentVariables';
// import { ReownWalletButton } from '../Wallets/AppKit/ReownWalletButton';
// import { WalletConnectWalletButton } from '../Wallets/AppKit/WalletConnectWalletButton';

export const EmailWalletsList = (props: {
	onChooseWallet: (walletName: VelocityWalletName) => void;
}) => {
	const handleReownWalletConnectedCb = useCallback(() => {
		props.onChooseWallet(
			VELOCITY_CUSTOM_WALLET_OPTIONS.APPKIT_WALLET_ADAPTER_NAME
		);
	}, [props.onChooseWallet]);

	useTryConnectAppKit(handleReownWalletConnectedCb);

	// Reown / WalletConnect wallet options are disabled for now.
	return null;

	// return (
	// 	<>
	// 		{Env.showAppKitWallet && <ReownWalletButton />}
	// 		<WalletConnectWalletButton />
	// 	</>
	// );
};
